import { footerColumns } from '@/mocks/homeData';

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-background-200/80 bg-background-100">
      <div className="mx-auto w-full max-w-shell px-4 py-14 md:px-6 md:py-20">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12 md:gap-8">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-fire-line text-lg" />
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">黑料在线</span>
            </div>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-foreground-600">
              把「今日新瓜」和「最新消息」按时间顺序摆好，热点区集中呈现，滚动爆料持续补新。想一口气看完整个事件的网友，从时间线开始就好。
            </p>
            <div className="mt-6 flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md border border-secondary-200 bg-secondary-50 text-secondary-700">
                <i className="ri-history-line text-base" />
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-md border border-secondary-200 bg-secondary-50 text-secondary-700">
                <i className="ri-link-m text-base" />
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-md border border-secondary-200 bg-secondary-50 text-secondary-700">
                <i className="ri-shield-check-line text-base" />
              </span>
            </div>
          </div>

          {footerColumns.map((column) => (
            <div key={column.title} className="md:col-span-2">
              <h4 className="text-sm font-semibold text-foreground-900">{column.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {column.links.map((link) => (
                  <li key={link}>
                    <a
                      href="#top"
                      className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="md:col-span-1">
            <h4 className="text-sm font-semibold text-foreground-900">回到</h4>
            <ul className="mt-4 space-y-2.5">
              <li>
                <a href="#top" className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                  顶部
                </a>
              </li>
              <li>
                <a href="#today" className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                  今日
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-background-200/80 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} 黑料在线 · 示范性内容，仅用于展示站点版式与结构</p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-2">
            <span>内容以公开渠道信息为基础整理</span>
            <span className="hidden sm:inline">·</span>
            <span>不收录涉及个人隐私的内容</span>
          </p>
        </div>
      </div>
    </footer>
  );
}